const TWO_DIGIT_LADAS = new Set(['55', '33', '81']);

export function formatPhone(raw: string | null | undefined): string {
  if (!raw) return '';
  let digits = raw.replace(/\D/g, '');

  // Strip Mexico country code (52) if present
  if (digits.length === 12 && digits.startsWith('52')) {
    digits = digits.slice(2);
  }

  if (digits.length !== 10) return raw; // not a standard MX number, return as-is

  const lada2 = digits.slice(0, 2);
  if (TWO_DIGIT_LADAS.has(lada2)) {
    // XX XXXX XXXX
    return `${lada2} ${digits.slice(2, 6)} ${digits.slice(6)}`;
  }
  // XXX XXX XXXX
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
}
